<template>
  <form @submit.prevent="handleSubmit(item)">
    <div class="form-group">
      <label
        for="exsbvatrate_createdAt"
        class="form-control-label">createdAt</label>
      <input
        id="exsbvatrate_createdAt"
        v-model="item.createdAt"
        :class="['form-control', isInvalid('createdAt') ? 'is-invalid' : '']"
        type="dateTime"
        placeholder=""
        @input="handleUpdateField('createdAt', $event.target.value)">
      <div
        v-if="isInvalid('createdAt')"
        class="invalid-feedback">{{ violations.createdAt }}</div>
    </div>
    <div class="form-group">
      <label
        for="exsbvatrate_updatedAt"
        class="form-control-label">updatedAt</label>
      <input
        id="exsbvatrate_updatedAt"
        v-model="item.updatedAt"
        :class="['form-control', isInvalid('updatedAt') ? 'is-invalid' : '']"
        type="dateTime"
        placeholder=""
        @input="handleUpdateField('updatedAt', $event.target.value)">
      <div
        v-if="isInvalid('updatedAt')"
        class="invalid-feedback">{{ violations.updatedAt }}</div>
    </div>
    <div class="form-group">
      <label
        for="exsbvatrate_deletedAt"
        class="form-control-label">deletedAt</label>
      <input
        id="exsbvatrate_deletedAt"
        v-model="item.deletedAt"
        :class="['form-control', isInvalid('deletedAt') ? 'is-invalid' : '']"
        type="dateTime"
        placeholder=""
        @input="handleUpdateField('deletedAt', $event.target.value)">
      <div
        v-if="isInvalid('deletedAt')"
        class="invalid-feedback">{{ violations.deletedAt }}</div>
    </div>
    <div class="form-group">
      <label
        for="exsbvatrate_createdBy"
        class="form-control-label">createdBy</label>
      <input
        id="exsbvatrate_createdBy"
        v-model="item.createdBy"
        :class="['form-control', isInvalid('createdBy') ? 'is-invalid' : '']"
        type="number"
        placeholder=""
        @input="handleUpdateField('createdBy', $event.target.value)">
      <div
        v-if="isInvalid('createdBy')"
        class="invalid-feedback">{{ violations.createdBy }}</div>
    </div>
    <div class="form-group">
      <label
        for="exsbvatrate_updatedBy"
        class="form-control-label">updatedBy</label>
      <input
        id="exsbvatrate_updatedBy"
        v-model="item.updatedBy"
        :class="['form-control', isInvalid('updatedBy') ? 'is-invalid' : '']"
        type="number"
        placeholder=""
        @input="handleUpdateField('updatedBy', $event.target.value)">
      <div
        v-if="isInvalid('updatedBy')"
        class="invalid-feedback">{{ violations.updatedBy }}</div>
    </div>
    <div class="form-group">
      <label
        for="exsbvatrate_deletedBy"
        class="form-control-label">deletedBy</label>
      <input
        id="exsbvatrate_deletedBy"
        v-model="item.deletedBy"
        :class="['form-control', isInvalid('deletedBy') ? 'is-invalid' : '']"
        type="number"
        placeholder=""
        @input="handleUpdateField('deletedBy', $event.target.value)">
      <div
        v-if="isInvalid('deletedBy')"
        class="invalid-feedback">{{ violations.deletedBy }}</div>
    </div>
    <div class="form-group">
      <label
        for="exsbvatrate_state"
        class="form-control-label">state</label>
      <input
        id="exsbvatrate_state"
        v-model="item.state"
        :class="['form-control', isInvalid('state') ? 'is-invalid' : '']"
        type="number"
        placeholder=""
        @input="handleUpdateField('state', $event.target.value)">
      <div
        v-if="isInvalid('state')"
        class="invalid-feedback">{{ violations.state }}</div>
    </div>
    <div class="form-group">
      <label
        for="exsbvatrate_range"
        class="form-control-label">range</label>
      <input
        id="exsbvatrate_range"
        v-model="item.range"
        :class="['form-control', isInvalid('range') ? 'is-invalid' : '']"
        type="text"
        placeholder=""
        @input="handleUpdateField('range', $event.target.value)">
      <div
        v-if="isInvalid('range')"
        class="invalid-feedback">{{ violations.range }}</div>
    </div>

    <button
      type="submit"
      class="btn btn-primary">Submit</button>
  </form>
</template>

<script>
export default {
  props: {
    handleSubmit: {
      type: Function,
      required: true
    },

    handleUpdateField: {
      type: Function,
      required: true
    },

    values: {
      type: Object,
      required: true
    },

    errors: {
      type: Object,
      default: () => {}
    },

    initialValues: {
      type: Object,
      default: () => {}
    }
  },

  computed: {
    // eslint-disable-next-line
    item () {
      return this.initialValues || this.values
    },

    violations () {
      return this.errors || {}
    }
  },

  methods: {
    isInvalid (key) {
      return Object.keys(this.violations).length > 0 && this.violations[key]
    }
  }
}
</script>
